import api, { PodcastConfiguration } from '@sparemin/api-sdk';
import { isPodcastBlockedFromTldlSelector } from 'api/selectors/podcast';
import { QueryFunctionContext, useQuery } from 'react-query';
import { podcastQueryKeys } from './queries';

export type UsePodcastConfigProps<TData = PodcastConfiguration> = {
  podcastId?: string;
  select?: (data: PodcastConfiguration) => TData;
};

function queryFn(
  ctx: QueryFunctionContext<ReturnType<typeof podcastQueryKeys.config>>,
) {
  const {
    queryKey: [{ podcastId }],
  } = ctx;

  return api.getPodcastConfiguration({ podcastId: String(podcastId) });
}

function useGetPodcastConfig<TData = PodcastConfiguration>({
  podcastId: podcastIdProp,
  select,
}: UsePodcastConfigProps<TData>) {
  return useQuery({
    queryKey: podcastQueryKeys.config(podcastIdProp),
    enabled: podcastIdProp !== undefined,
    select,
    queryFn,
  });
}

export const useIsPodcastBlockedFromTldl = (podcastId?: string) =>
  useGetPodcastConfig({
    podcastId,
    select: isPodcastBlockedFromTldlSelector,
  });
